var themeFlix = {
	"brand-primary-color": "#97d700",
	"ui-primary-color": "#31a100",
	"ui-primary-light-color": "#5cc500",
	"ui-primary-dark-color": "#187d00",
	"grayscale-0-color": "#ffffff",
	"grayscale-10-color": "#f7f7f7",
	"grayscale-30-color": "#e1e1e1",
	"grayscale-50-color": "#c8c8c8",
	"grayscale-70-color": "#646464",
	"grayscale-90-color": "#444444",
	"grayscale-100-color": "#353535",
	"neutral-color": "#016ae7",
	"success-color": "#228f00",
	"success-dark-color": "#136b00",
	"warning-color": "#ff5704",
	"warning-dark-color": "#c42d00",
	"danger-color": "#dd2828",
	"danger-dark-color": "#b31414",
	"bg-primary-color": "#ffffff",
	"bg-primary-transparent-color": "rgba(255, 255, 255, 0.88)",
	"bg-secondary-color": "#f7f7f7",
	"box-bg-color": "#ffffff",
	"highlight-color": "#e5f9c0",
	"overlay-bg-color": "rgba(0, 0, 0, 0.5)",
	"focus-outline-color": "#016ae7",
	"content-primary-color": "#353535",
	"content-secondary-color": "#646464",
	"heading-font-color": "#353535",
	"link-color": "#0047de",
	"line-primary-color": "#c8c8c8",
	"icon-primary-color": "#848484",
	"icon-secondary-color": "#97d700",
	"icon-background-color": "#353535",
	"box-shadow-color": "rgba(0, 0, 0, 0.18)",
	"box-shadow-subtle-color": "rgba(0, 0, 0, 0.06)",
	"button-primary-color": "#97d700",
	"button-label-color": "#353535",
	"header-bg-color": "#97d700",
	"header-color": "#353535",
	"header-nav-bg-color-tablet": "#5cc500",
	"input-border-color": "#848484",
	"input-height-mobile": "44px",
	"input-height-desktop": "36px",
	"spacing-1": "6px",
	"spacing-2": "12px",
	"spacing-3": "18px",
	"spacing-4": "24px",
	"spacing-5": "30px",
	"spacing-6": "36px",
	"spacing-7": "42px",
	"spacing-8": "48px",
	"spacing-9": "54px",
	"spacing-10": "60px",
	"spacing-11": "66px",
	"spacing-12": "72px",
	"spacing-half": "3px",
	"grid-gutter-2": "12px",
	"grid-gutter-4": "24px",
	"page-min-width": "320px",
	"page-max-width": "1200px",
	"font-size-base": "1rem",
	"font-size-primary": "1rem",
	"font-size-small": ".875rem",
	"font-size-fineprint": ".75rem",
	"font-size-h1": "1.7rem",
	"font-size-h2": "1.3rem",
	"font-size-h3": "1.1rem",
	"font-size-h4": "1rem",
	"line-height-primary": "1.5rem",
	"line-height-small": "1.125rem",
	"line-height-fineprint": ".938rem",
	"line-height-h1": "2rem",
	"line-height-h2": "1.7rem",
	"line-height-h3": "1.5rem",
	"line-height-h4": "1.5rem",
	"hover-layer-color": "linear-gradient(rgba(0, 0, 0, 0.06), rgba(0, 0, 0, 0.06))",
	"pressed-layer-color": "linear-gradient(rgba(0, 0, 0, 0.12), rgba(0, 0, 0, 0.12))",
	"disabled-element-opacity": 0.5,
	"primary-border-radius": "6px",
	"border-radius-1": "6px",
	"border-radius-2": "12px",
	"border-radius-half": "3px",
	"primary-box-shadow": "0px 6px 12px rgba(0, 0, 0, .06), 0px 3px 18px rgba(0, 0, 0, .06), 0px 3px 6px rgba(0, 0, 0, .18)",
	"color-scheme": "normal",
	"font-family-primary": "Roboto, Arial, sans-serif",
	"font-weight-normal": "400",
	"font-weight-semibold": "500",
	"font-weight-bold": "700"
};

export { themeFlix as default };
